import { render, staticRenderFns } from "./PageSectorTree.vue?vue&type=template&id=0a6a4484"
import script from "./PageSectorTree.vue?vue&type=script&lang=js"
export * from "./PageSectorTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6a4484')) {
      api.createRecord('0a6a4484', component.options)
    } else {
      api.reload('0a6a4484', component.options)
    }
    module.hot.accept("./PageSectorTree.vue?vue&type=template&id=0a6a4484", function () {
      api.rerender('0a6a4484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PageSectorTree.vue"
export default component.exports